module.exports = __webpack_public_path__ + "img/tutuyoutoo.4e654ef0.svg";